import React from 'react';
import Popover from 'react-awesome-popover';
import Button from '../Button';

import { transactionTypes } from './lookups';
import './styles.css';

const styles = {
  popoverBody: {
    padding: '8px 15px',
    position: 'absolute',
    top: '-52px',
    display: 'block',
    background: '#ffffff',
    minWidth: '228px',
    color: '#1b60a9',
    borderRadius: '20px',
    fontWeight: 'normal',
    border: 'solid 1px #1b60a9',
    left: '-28px',
  },
  btn: {
    border: 'none',
    fontSize: '16px',
    color: '#1b60a9',
    fontWeight: 'bold',
    marginLeft: '5px',
    outline: 'none',
    cursor: 'pointer',
    background: 'none',
  },
  'btn:hover, btn:active': {
    outline: 'none',
    fontWeight: 'bold',
  },
};

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onCancelRefuse() {
    this.setState({
      open: false,
    });
  }

  togglePopover() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    const {
      transactionType,
      onCancel,
    } = this.props;
    return (
      <Popover placement="bottom-start" open={this.state.open} action={null}>
        <Button type="button" className="btn mediumBtn" onClick={() => this.togglePopover()}>
          Cancel {transactionType === transactionTypes.MONEY_TRANSACTION ? 'Transfer' : 'Order'}
        </Button>
        <div style={styles.popoverBody}>
          <span>Are you sure?</span>
          <button style={styles.btn} onClick={onCancel}>Yes</button>
          <button style={styles.btn} onClick={() => this.onCancelRefuse()}>No</button>
        </div>
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/History/CancellationBtn.js